import React from "react";

function Heading({ text, showRight, id }) {
  if (id == undefined) {
    id = "";
  }
  return (
    <div id={id} className="flex justify-between items-center mx-4 my-4">
      <h1 className="text-2xl font-bold primary-color">{text}</h1>
      {showRight != null ? (
        <div className="text-white text-xs uppercase ">{showRight}</div>
      ) : null}
    </div>
  );
}

export default Heading;
